const fragment = `
  accessToken
  refreshToken
  createdAt
  expiresIn
`;

export const loginQuery = `
  mutation login($email: String!, $password: String!, $deviceToken: String) {
    loginResponse: login(email: $email, password: $password, deviceToken: $deviceToken) {
      require2FA
      authMedium
      authData {
        ${fragment}
      }
    }
  }
`;

export const getTokenQuery = `
  mutation getToken($refreshToken: String!) {
    authData: token(refreshToken: $refreshToken) {
      ${fragment}
    }
  }
`;

export const loginWith2FAQuery = `
  mutation loginWith2FACode($code: String!, $deviceToken: String) {
    authData: loginWith2FACode(code: $code, deviceToken: $deviceToken) {
      ${fragment}
    }
  }
`;

export const resend2FACodeQuery = `
  mutation resend2FACode($email: String!, $authMedium: String!) {
    sent: resend2FACode(email: $email, authMedium: $authMedium)
  }
`;

export const validateEmailAndSendResetPasswordLinkQuery = `
  mutation validateEmailAndSendResetPasswordLink($email: String!) {
    sent: validateEmailAndSendResetPasswordLink(email: $email)
  }
`;

export const resetPasswordQuery = `
  mutation resetPassword($input: ResetPasswordResponseInput!) {
    reset: resetPassword(input: $input)
  }
`;

export const validateResetPasswordTokenQuery = `
  mutation validateResetPasswordToken($token: String!) {
    isValid: validateResetPasswordToken(token: $token)
  }
`;

export const validateUserInvitationTokenQuery = `
  mutation validateUserInvitationToken($token: String!) {
    isValid: validateUserInvitationToken(token: $token)
  }
`;

export const sendSalesMagicLinkMutation = `
  mutation SendSalesMagicLink($email: String!) {
    sent: sendSalesMagicLink(email: $email)
  }
`;

export const sendSalesOtpMutation = `
  mutation SendSalesOtp($email: String!) {
    sent: sendSalesOtp(email: $email)
  }
`;

export const salesPasswordlessLoginMutation = `
  mutation SalesPasswordlessLogin(
    $token: String!
    $email: String
    $deviceToken: String
  ) {
    authData: salesPasswordlessLogin(token: $token, email: $email, deviceToken: $deviceToken) {
      ${fragment}
    }
  }
`;
